import React from 'react';
import styled from 'styled-components';
const Icon = styled.svg``;
export default (() => /*#__PURE__*/React.createElement(Icon, {
  width: "16px",
  height: "24px",
  viewBox: "0 0 16 11",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-arrow-up",
  points: "10.5 3 13.5 3 13.5 13.5 3 13.5 3 10.5 10.5 10.5"
})), /*#__PURE__*/React.createElement("g", {
  id: "4-Icons",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-arrow-up",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-arrow-up"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#FFFFFF",
  fillRule: "nonzero",
  transform: "translate(8.250000, 8.250000) scale(-1, 1) rotate(-135.000000) translate(-8.250000, -8.250000) ",
  xlinkHref: "#path-arrow-up"
}))));